import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import instance from '../../api/axios/utils.ts/instance';
import { AxiosParamType } from '.';
import { ApiResponse } from '../../constants/types';
import { LmsLinkItem } from '../../constants/types/lms/type';

interface stateObj {
  status: string;
  lmsLink: { links: LmsLinkItem[] };
}

const initialState: stateObj = {
  status: '',
  lmsLink: undefined,
};

export const getLmsLink = createAsyncThunk<
  { links: LmsLinkItem[] },
  AxiosParamType
>('lms-link/getLmsLink', async ({ url, params }) => {
  const response = await instance.get<ApiResponse<{ links: LmsLinkItem[] }>>(
    url,
    {
      params,
    },
  );

  return response.data.data;
});

export const lmsLinkSlice = createSlice({
  name: 'lms-link',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getLmsLink.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(getLmsLink.fulfilled, (state, action) => {
        state.status = 'fulfilled';
        state.lmsLink = action.payload;
      })
      .addCase(getLmsLink.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const selectLmsLink = (state: RootState) => state['lms-link'].lmsLink;

export default lmsLinkSlice.reducer;
